import { SplideShaderCarouselOptions } from '../types';

/**
 * Default options.
 *
 * @since 0.0.1
 */
export const DEFAULTS: SplideShaderCarouselOptions = {
  awaitInit: true,
};